@if (canShowZoneIndicators()) {
  <div [style.width.px]="productionScheduleVerifyWidth" class="zone-indicator-line">
    @for (zone of zones; track $index) {
      <div class="zone-indicator-container">
        <vdw-zone-input
          [disabled]="!productionSchedule.canBeModified()"
          [technicalValue]="zone.technicalWidthInDents"
          [commercialValueInMM]="getZoneWidthInMM(zone)"
          [maximumTechnicalValue]="maximumTechnicalValue()"
          [zoneType]="getZoneInputType(zone)"
          [zoneKey]="getZoneInputType(zone) + '-' + $index"
          [style.left.px]="getZoneIndicatorPosition($index)"
          (valueChanged)="onZoneValueChanged($event, zone)"
        />
      </div>
    }
  </div>
}
